<template lang="pug">
v-card(outlined).mb-5
  v-card-title Изменение пароля
    v-btn.rounded.ml-auto(@click="show = !show"  fab small)
      v-icon mdi-cog

  v-expand-transition
    v-card-text(v-if="show")
      v-form(v-model="valid")
        password-input(
          v-model="form.old_password"
          :rules="[rules.required]"
          filled
          label="Старый пароль"
          required
        )
        password-input(v-model="form.password"
          :rules="[rules.required, rules.min(6), rules.same(form.password_confirmation)]"
          filled
          :key="'password' + form.password_confirmation"
          label="Новый пароль"
        )
        password-input(v-model="form.password_confirmation"
          :rules="[rules.required, rules.min(6), rules.same(form.password)]"
          filled
          :key="'password_confirmation' + form.password"
          label="Повтор пароля"
        )
      v-btn(
        :loading="loadingUpdate"
        :disabled="!valid"
        @click="updateProfile"
        color="primary"
      ) Обновить
</template>

<script>
import { mapGetters } from 'vuex';
import rules from '@/lib/rules';
import userService from '@/services/API/user';
import PasswordInput from '@/components/inputs/PasswordInput.vue';

const DEFAULT_FORM = {
  old_password:'',
  password:'',
  password_confirmation:'',
};

export default {
  components:{ PasswordInput },
  data() {
    return {
      show: false,
      valid: false,

      loadingUpdate:false,
      form: { ...DEFAULT_FORM },
      rules,
    };
  },
  computed: {
    ...mapGetters({
      'user':'auth/getUser',
    }),
  },

  methods: {
    async updateProfile() {
      try {
        this.loadingUpdate = true;
        const response = await userService.updatePassword(this.user.id, this.form);
        this.setUser(response.data.data);
        this.$toast.success('Пароль успешно изменен');
      } catch (error) {
        this.$toast.error(error.response.data.data.message);
      } finally {
        this.loadingUpdate = false;
      }
    },

  },
};
</script>

<style></style>
